/**
 * Original supplied artwork, framed by SVG viewBoxes to remove excess margins.
 * Keep the filled variant rounded so its white outer corners blend on dark panels.
 */
export default function BrandLogo({ filled = false, className = '', decorative = false }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/brand/startin-logo${filled ? '-filled' : ''}.svg`}
      alt={decorative ? '' : 'STArtIn AI'}
      width={filled ? 821 : 444}
      height={filled ? 822 : 518}
      className={`block shrink-0 object-contain ${filled ? 'rounded-[20%]' : ''} ${className}`}
      draggable={false}
    />
  );
}